<template lang='pug'></template>

<script>
import {
  app,
} from '../functions/initializeApp'

import {
  getAuth,
  onAuthStateChanged,
} from 'firebase/auth'

const mounted = function ()
{
  const auth = getAuth(app)

  onAuthStateChanged
  (
    auth,
    result => this.$emit('onAuthStateChanged', result)
  )
}

export default
{
  mounted
}
</script>